import {useRefInfo} from '../contexts/RefInfoContext'
import {useCurrentRepository} from '@github-ui/current-repository'
import {fetchAndMergePath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'
import {useCallback} from 'react'

export function useBranchUpdater() {
  const repo = useCurrentRepository()
  const {name} = useRefInfo()

  const discardPath = fetchAndMergePath({repo, refName: name, discard: true})
  const updatePath = fetchAndMergePath({repo, refName: name, discard: false})

  const updateBranch = useCallback(() => {
    return verifiedFetch(updatePath, {method: 'POST'})
  }, [updatePath])

  const discardChanges = useCallback(() => {
    return verifiedFetch(discardPath, {method: 'POST'})
  }, [discardPath])

  return {updateBranch, discardChanges}
}
